<template>
  <div>
    <ol-tooltip>
      <template #activator="{ on }">
        <div
          style="line-height: 0"
          v-on="on"
        >
          <v-icon
            v-show="lastActionInfo.lastActionWeeksWarning1"
            small
            :class="{
              'warning--text':
                lastActionInfo.lastActionWeeksWarning1 &&
                !lastActionInfo.lastActionWeeksWarning2,
              'error--text': lastActionInfo.lastActionWeeksWarning2
            }"
            class="text--darken-2"
          >
            mdi-clock-alert-outline
          </v-icon>
        </div>
      </template>
      <span>
        Last modified more than {{ lastActionInfo.lastActionWeeksText }} weeks
        ago ({{ dateString }})
      </span>
    </ol-tooltip>
    {{ dateString }}
  </div>
</template>

<script>
export default {
  name: 'ModifiedColumn',
  props: {
    lastActionInfo: { type: Object, default: () => ({}) }
  },
  computed: {
    dateString() {
      return this.lastActionInfo.lastActionDate.toDate().toLocaleString()
    }
  }
}
</script>
